import React from 'react';
import { TOWER_TYPE_COLORS, TOWER_TYPE_GLOW, TOWER_TYPE_LABELS, TOWER_TYPES } from '../hooks/useRotationOrder';

const STEP_ICONS = {
  [TOWER_TYPES.NEUTRAL]: '🗿',
  [TOWER_TYPES.FIRE]: '🔥',
  [TOWER_TYPES.LIGHTNING]: '⚡',
  [TOWER_TYPES.ICE]: '❄️',
};

export default function RotationList({ rotationOrder, towerTypes, showOrder }) {
  if (rotationOrder.length === 0) {
    return (
      <div className="rotation-empty">
        <p>Selecione o tipo de cada torre no mapa para ver a rotação ideal.</p>
      </div>
    );
  }

  return showOrder && (
    <div className="rotation-list">
      <h2 className="rotation-title">⚔️ Ordem de Rotação</h2>
      <div className="rotation-steps">
        {rotationOrder.map((tower, idx) => {
          const type = towerTypes[tower.id];
          const color = TOWER_TYPE_COLORS[type];
          const glow = TOWER_TYPE_GLOW[type];
          const label = TOWER_TYPE_LABELS[type];
          const icon = STEP_ICONS[type];

          return (
            <div
              key={tower.id}
              className="rotation-step"
              style={{
                borderColor: color,
                boxShadow: `0 0 10px 2px ${glow}40`,
              }}
            >
              <div className="step-number" style={{ background: color, boxShadow: `0 0 8px 2px ${glow}` }}>
                {idx + 1}
              </div>
              <div className="step-info">
                <span className="step-icon">{icon}</span>
                <span className="step-tower">{tower.label}</span>
                {/*<span className="step-sector">Setor {tower.sector}</span>*/}
              </div>
              <div className="step-type" style={{ color }}>
                {label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

